module.exports = __webpack_public_path__ + "static/media/logo-ipm2.11a05685.svg";